import { newToolFilterOAuthMcp } from "../oauth.ts";

export const parallelTaskMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://parallel.ai/apple-icon.png",
  url: "https://task-mcp.parallel.ai/mcp",
  label: "Parallel Task",
});
